const specialPromotionStyle = Object.freeze({
  primary: Object.freeze({
    button: 'neutralOpaque',
    icon: [ 'secondary', '-2', ],
  }),
  primaryInverse: Object.freeze({
    button: 'secondary',
    icon: [ 'tertiary', '-4', ],
  }),
});

export default specialPromotionStyle;
